import { ImagesContainer } from 'components/shared';
import { usePalletsTypes } from 'constants/palletTypes';
import { useReportTypeLabels } from 'constants/reportTypes';
import { DamagedPalletDTO } from 'interfaces';
import { TableCell, TableRow } from 'storybook';

type DamagedLostPalletsTableSubRowProps = {
   damagedPalletsItem: DamagedPalletDTO;
   isReceivedDamaged: boolean;
};

const DamagedLostPalletsTableSubRow = ({
   damagedPalletsItem,
   isReceivedDamaged,
}: DamagedLostPalletsTableSubRowProps) => {
   const { PALLET_TYPE_LABELS } = usePalletsTypes();
   const { REPORT_TYPE_LABELS } = useReportTypeLabels();

   return (
      <TableRow>
         <TableCell />
         <TableCell />
         {isReceivedDamaged && (
            <TableCell>{REPORT_TYPE_LABELS[damagedPalletsItem.reportType]}</TableCell>
         )}
         <TableCell>{PALLET_TYPE_LABELS[damagedPalletsItem.type]}</TableCell>
         <TableCell align="right">{damagedPalletsItem.amount}</TableCell>
         {isReceivedDamaged && (
            <TableCell>
               <ImagesContainer imageURLs={damagedPalletsItem.images} />
            </TableCell>
         )}
      </TableRow>
   );
};
export default DamagedLostPalletsTableSubRow;
